import script from "./GarmentRenderLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./GarmentRenderLayer.vue?vue&type=script&setup=true&lang=js"

import "./GarmentRenderLayer.vue?vue&type=style&index=0&id=3c94f4c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c94f4c5"]])

export default __exports__